import React, { useEffect } from "react";
import "./AddContacts.css";
import ContactForm from "../../components/Forms/ParticipantAddContactsForm";
import bearImage from "../../images/bear_on_computer.png";

const ParticipantAddContacts = () => {
  useEffect(() => {
    document.title = "Add Contacts";
  }, []);
  return (
    <div className="participant-add-contacts-container">
      <div className="content-wrapper">
        <div className="left-section">
          <header className="header-section">
            <div className="add-contact-heading-primary">
              Add your contacts here!
            </div>
            <div className="add-contact-paragraph">
              Here, we believe that building a strong fundraiser network begins
              with your participation.
            </div>
            <div className="add-contact-paragraph">
              We are delighted to offer a modern and user-friendly service to
              ensure you have the best experience.
            </div>
            <div className="add-contact-paragraph">
              We will send out emails to your contacts, please let them know to
              expect an email from us! If they don't see it have them check
              their spam folder!
            </div>
          </header>
          <div className="image-section">
            <img src={bearImage} alt="Bear with Laptop" />
          </div>
        </div>
        <div className="right-section">
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default ParticipantAddContacts;
